import React from 'react';
import { ArrowRight } from 'lucide-react';

const CALENDLY_URL = 'https://calendly.com/swallacemeeting/bizdevconsult';

const studies = [
  {
    industry: 'SaaS',
    headline: '$11K to $30K MRR',
    growth: '173% Growth',
    timeframe: '6 months',
    story: 'SaaS founder went from struggling to book demos to hiring reps and booking trade shows.',
  },
  {
    industry: 'Financial Services',
    headline: '$50M Pipeline',
    growth: '2x Pipeline',
    timeframe: '60 days',
    story: 'Financial advisor doubled pipeline while working fewer hours. One meeting per dial session.',
  },
  {
    industry: 'Marketing Agency',
    headline: '$250K Pipeline',
    growth: 'New Market Entry',
    timeframe: '30 days',
    story: 'CEO went from burnout to leading like a CEO with dozens of qualified opportunities.',
  },
];

const CaseStudies = () => {
  return (
    <section id="results" data-testid="case-studies-section" className="section" style={{ backgroundColor: 'var(--bg-secondary)' }}>
      <div className="container">
        <div className="text-center mb-16">
          <h2 className="heading-lg mb-4">The Numbers Don't Lie</h2>
          <p className="text-base md:text-lg" style={{ color: 'var(--text-secondary)' }}>
            Here's what happens when you stop guessing and start building systems.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {studies.map((s) => (
            <div key={s.industry} className="card text-center" data-testid={`case-study-${s.industry.toLowerCase().replace(/\s+/g, '-')}`}>
              <span
                className="text-xs font-bold uppercase tracking-wider mb-4 inline-block px-3 py-1 rounded-full"
                style={{ backgroundColor: 'var(--bg-accent)', color: 'var(--brand-primary)' }}
              >
                {s.industry}
              </span>
              <h3 className="text-3xl font-extrabold mb-1" style={{ color: 'var(--text-primary)' }}>
                {s.headline}
              </h3>
              <p className="font-semibold mb-1" style={{ color: 'var(--brand-success)' }}>{s.growth}</p>
              <p className="text-sm mb-4" style={{ color: 'var(--text-muted)' }}>in {s.timeframe}</p>
              <p className="text-sm" style={{ color: 'var(--text-secondary)' }}>{s.story}</p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <a
            href={CALENDLY_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary text-lg px-8 py-4"
            data-testid="case-studies-cta"
            aria-label="Book a call to get similar results"
          >
            Get Results Like These
            <ArrowRight className="ml-2 w-5 h-5" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default CaseStudies;
